import userApi from '../../request/userApi';

const state = {
	userData: null,
	loginSuccess: false,
	token: '', // UserNo
	authtoken: '', // token
	menuList: [],
	
}

// 以计算属性形式返回
const getters = {

}

// 异步获取值后commit mutations更改值
const actions = {
	getUserData({
		commit,
		state
	}) {
		if (state.IsLogin) {
			userApi.getUserData(state.OpenId).then(sucRes => {
				let result = sucRes;
				if (result.success) {
					commit('setUserData', result.data);
					return true;
				} else {
					return false;
				}
			});
		}
	}
}

// 更改值
const mutations = {
	setData(state, dataObj) {
		for (let prop in dataObj) {
			if (dataObj[prop] !== undefined) {
				state[prop] = dataObj[prop];
			}
		}
	},
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js